export const ROLLOUTS = {
    CHEETAHS_BOOK_PUBLISHING: 'cheetahs_book_publishing',
    LYNXES_TIKTOK_SHOP_SERVICE: 'lynxes_tiktok_shop_service',
};
